import { render, staticRenderFns } from "./water-cons.vue?vue&type=template&id=46828dd3&scoped=true&"
import script from "./water-cons.vue?vue&type=script&lang=js&"
export * from "./water-cons.vue?vue&type=script&lang=js&"
import style0 from "./water-cons.vue?vue&type=style&index=0&id=46828dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46828dd3",
  null
  
)

export default component.exports